import React from "react";
import { ScriptableContainer } from "./ScriptableContainer";

export const ScriptableContainerContext = React.createContext<ScriptableContainer | undefined>(undefined);